
const footerLinks = [
    { label: "Terms", url: "https://www.newsmax.com/termsconditions/?utm_source=nmplus&utm_medium=footer" },
    { label: "Privacy", url: "https://www.newsmax.com/privacystatement/?utm_source=nmplus&utm_medium=footer" },
    { label: "About", url: "https://www.newsmax.com/about/?utm_source=nmplus&utm_medium=footer" },
    { label: "Contact", url: "https://www.newsmax.com/contact/?utm_source=nmplus&utm_medium=footer" },
    { label: "Newsmax.com", url: "https://www.newsmax.com/?utm_source=nmplus&utm_medium=footer" },
    { label: "NewsmaxTV.com", url: "https://www.newsmaxtv.com/?utm_source=nmplus&utm_medium=footer" },
    { label: "NewsmaxPlus.com", url: "https://www.newsmaxplus.com/?utm_source=nmplus&utm_medium=footer" },
];

/**
 * Handles navigation based on the environment. If it's a WebView, it navigates in the same window; otherwise, it opens the URL in a new tab for standard browsers.
 * @param {any} e
 * @param {any} url
 * @param {any} isWebView
 */
const handleNav = (e) => {
    e.preventDefault();
    const { isWebView } = detectEnvironment();
    //console.log(e)
    if (isWebView) {
        window.location.href = e.target.href; // explicit navigation for WebViews
    } else {
        window.open(e.target.href, "_blank", "noopener,noreferrer"); // normal browser: new tab
    }
};

/**
 * Detects if the current environment is a WebView or a standard browser by analyzing the user agent string and checking for specific properties.
 * @returns
 */
function detectEnvironment() {
    const ua = navigator.userAgent;
    const checks = {
        // iOS WebView: has AppleWebKit but NOT Safari in UA
        iosWebView: /iphone|ipad|ipod/i.test(ua) && /applewebkit/i.test(ua) && !/safari/i.test(ua),
        // Android WebView: explicit wv flag or old WebView UA pattern
        androidWebView: /android/i.test(ua) && (/wv\)/.test(ua) || /version\/\d+\.\d+.*chrome\/\d+/i.test(ua)),
        // Facebook, Instagram, Twitter/X in-app browsers
        facebook: /fban|fbav/i.test(ua),
        instagram: /instagram/i.test(ua),
        twitter: /twitter/i.test(ua),
        // Generic WebView signals
        genericWebView: /webview/i.test(ua),
        // Environment capability checks
        noSafariObj: typeof window.safari === "undefined",
        noOpenDB: typeof window.openDatabase === "undefined",
    };

    const isWebView =
        checks.iosWebView ||
        checks.androidWebView ||
        checks.facebook ||
        checks.instagram ||
        checks.twitter ||
        checks.genericWebView;

    return { isWebView, checks };
}

export { handleNav, detectEnvironment, footerLinks };